<template>
  <el-dialog
    :visible.sync="visible"
    width="900px"
    class="purchase-list-dialog"
    :show-close="false"
    center
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="dialog-header">
      <img src="@/assets/images/logo-active.png" :alt="getText('purchaseListDialog.logoAlt', '亚科Logo')" class="logo" />
      <button class="close-btn" @click="closeDialog">×</button>
    </div>
    <div class="table-container">
      <div class="table-box">
        <div class="table-header">
          <div class="col col-info">{{ getText('purchaseListDialog.productInfo', '产品信息') }}</div>
          <div class="col col-price">{{ getText('purchaseListDialog.unitPrice', '单价（含税）') }}</div>
          <div class="col col-more">{{ getText('purchaseListDialog.more', '更多') }}</div>
        </div>
        <div class="table-body">
          <div
            class="table-row"
            v-for="(item, idx) in list"
            :key="idx"
          >
            <div class="col col-info">
              <div class="prod-title">{{ item.name }}</div>
              <div class="prod-info">
                <div>{{ getText('purchaseListDialog.productCode', '商品编号：') }}{{ item.b2starNo }}</div>
                <div>{{ getText('purchaseListDialog.itemNumber', '货号：') }}{{ item.sn }}</div>
                <div>{{ getText('purchaseListDialog.specification', '规格：') }}{{ item.specification }}</div>
                <div>{{ getText('purchaseListDialog.parameter', '参数：') }}{{ item.param }}</div>
              </div>
            </div>
            <div class="col col-price">
              <div class="price" v-if="item.price !== '0.0'">￥{{item.price}}<span class="unit">/{{item.unitName}}</span></div>
              <div class="price" v-else>{{ getText('purchaseListDialog.contactSales', '联系销售询价') }}</div>
            </div>
            <div class="col col-more">
              <el-button type="primary" size="mini" @click="goToShop(item)">{{ getText('purchaseListDialog.gotoShop', '前往商城查看') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-box">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </div>
    <div class="dialog-footer">
      <img src="@/assets/images/yssc-logo.png" alt="bztstar" class="bztstar" />
      <span>{{ getText('purchaseListDialog.storeInfo', '由亚科集团旗下元素商城提供服务') }}</span>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PurchaseListDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  
  watch: {
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 强制重新渲染组件以更新文本
          this.$forceUpdate()
        }
      },
      immediate: false
    }
  },
  
  computed: {
    ...mapState({
      currentLanguage: state => state?.app?.language || 'zh' 
    })
  },
  
  methods: {
    // 安全的文本获取方法
    getText(key, fallback) {
      try {
        // 尝试使用 i18n
        if (this.$i18n && this.$i18n.t) {
          return this.$i18n.t(key)
        }
        // 如果 i18n 不可用，返回默认值
        return fallback
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error)
        return fallback
      }
    },
    
    goToShop(item) {
      this.$emit('update:visible', false)
      window.open('https://www.b2star.com' + item.goodsUrl, '_blank')
    },
    closeDialog() {
      this.$emit('update:visible', false)
    },
    handlePageChange(page) {
      // 通知父组件切换页码，父组件负责请求新数据
      this.$emit('page-change', page)
    }
  }
}
</script>

<style scoped lang="less">
@import '../assets/styles/variables.less';
.purchase-list-dialog ::v-deep .el-dialog__header {
  display: none;
}
.table-container {
  max-height: 420px;
  overflow-y: auto;
  margin-bottom: 16px;
}
.table-box {
  background: #fff;
  border-radius: 4px;
  margin: 0 0 20px 0;
}
.table-header {
  display: flex;
  background: #f7f7f7;
  border-radius: 4px 4px 0 0;

  font-size: 16px;
  color: #333;
  border-bottom: 1px solid #e5e5e5;
}
.table-body {
  max-height: 350px;
  overflow-y: auto;
}
.table-row {
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;
  transition: background 0.2s;
}
.table-row:last-child {
  border-bottom: none;
}
.col {
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.col-info {
  flex: 2.5;
  font-size: 15px;
  color: #222;
}
.col-price {
  flex: 1.2;
  align-items: flex-end;
  text-align: right;
  font-size: 18px;
  color: #e60012;
  font-weight: 600;
  justify-content: center;
}
.col-more {
  flex: 1;
  align-items: flex-end;
  justify-content: center;
  text-align: right;
}
.prod-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 6px;
}
.prod-info {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
}
.price {
  color: #e60012;
  font-size: @font-size-note;
  font-weight: 600;
}
.old-price {
  color: #bbb;
  font-size: 14px;
  text-decoration: line-through;
  margin-top: 4px;
}
.unit {
  font-size: 15px;
  font-weight: 400;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 18px;
  color: #888;
  font-size: 14px;
}
.bztstar {
  height: 22px;
  margin-right: 8px;
}
.pagination-box {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.close-btn {
  position: absolute;
  right: 20px;
  top: 18px;
  background: none;
  border: none;
  font-size: 28px;
  color: #888;
  cursor: pointer;
  outline: none;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #e60012;
}
.dialog-header {
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px 0 20px 0;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 10px;
}
.logo {
  width: auto;
  height: 40px;
}
</style>